import { observer } from "mobx-react-lite";
import { Row, Spinner } from "react-bootstrap";
import { useContext } from "react";
import { Context } from "../index";
import DetailItem from "./DetailItem";

const DetailList = observer(() => {
  const { detail } = useContext(Context);

  if (detail.isLoading) {
    return (
      <Row className="d-flex justify-content-center">
        <Spinner animation="border" />
      </Row>
    );
  }

  if (!detail.details.length) {
    return (
      <Row className="d-flex justify-content-center">
        <p>Ничего не найдено</p>
      </Row>
    );
  }

  return (
    <Row className="d-flex">
      {detail.details.map((detail) => (
        <DetailItem key={detail.id} detail={detail} />
      ))}
    </Row>
  );
});

export default DetailList;